var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "div",
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "content-title" },
                      [
                        _c("b-row", [
                          _c("h1", [
                            _vm._v("Reconciliation Rules Configuration"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("b-row", [
                          _c("span", [
                            _vm._v(
                              "Configure the 4-step matching cascade and candidate selection strategy"
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticClass: "card px-6 pt-6",
                        staticStyle: { "background-color": "#f8fafc" },
                      },
                      [
                        _c("div", { staticClass: "flex items-center" }, [
                          _c(
                            "h4",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "1rem",
                                "font-size": "1.5rem",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa-regular fa-filter" }),
                              _vm._v("Universal Filters (Hard-coded)"),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "subtitle",
                            attrs: { "data-slot": "card-description" },
                          },
                          [
                            _vm._v(
                              "These filters are always applied first. Payments failing these are rejected or flagged as exceptions."
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "grid",
                              "grid-template-columns": "1fr 1fr 1fr 1fr",
                              width: "100%",
                              gap: "1rem",
                              margin: "1rem 0rem",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "grid",
                                  "background-color": "white",
                                  border: "1px solid #e2e8f0",
                                  padding: "1rem",
                                  "border-radius": "0.25rem",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("1. VIBAN Check")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#45556c" } },
                                  [_vm._v("Must exist & be active")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "grid",
                                  "background-color": "white",
                                  border: "1px solid #e2e8f0",
                                  padding: "1rem",
                                  "border-radius": "0.25rem",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("2. Client Check")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#45556c" } },
                                  [_vm._v("Client active & not suspended")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "grid",
                                  "background-color": "white",
                                  border: "1px solid #e2e8f0",
                                  padding: "1rem",
                                  "border-radius": "0.25rem",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("3. Status Check")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#45556c" } },
                                  [_vm._v("Invoice must be Definitive/Open")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "grid",
                                  "background-color": "white",
                                  border: "1px solid #e2e8f0",
                                  padding: "1rem",
                                  "border-radius": "0.25rem",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("4. Payment Window")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#45556c" } },
                                  [_vm._v("Inside term + grace period")]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-row", { staticClass: "card px-6 pt-6" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Configuration Template"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "subtitle" }, [
                        _vm._v("Select a base configuration"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "grid",
                            "grid-template-columns": "1fr 1fr 1fr",
                            gap: "1rem",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card px-6 pt-6",
                              style: {
                                cursor: "pointer",
                                border:
                                  _vm.configuration == "ecommerce"
                                    ? "2px solid #bfdbfe"
                                    : "1px solid #0000001a",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateConfiguration("ecommerce")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "3rem",
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("E-commerce Standard"),
                                  ]),
                                  _vm._v(" "),
                                  _vm.configuration == "ecommerce"
                                    ? _c("i", {
                                        staticClass: "fa-regular fa-check",
                                        staticStyle: {
                                          color: "#bfdbfe",
                                          "font-weight": "bold",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    margin: "1rem 0rem",
                                    color: "#4a5565",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Optimized for high-volume e-commerce with exact matching and minimal tolerance"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "card px-6 pt-6",
                              style: {
                                cursor: "pointer",
                                border:
                                  _vm.configuration == "traditional"
                                    ? "2px solid #bfdbfe"
                                    : "1px solid #0000001a",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateConfiguration("traditional")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "3rem",
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("Traditional B2B"),
                                  ]),
                                  _vm._v(" "),
                                  _vm.configuration == "traditional"
                                    ? _c("i", {
                                        staticClass: "fa-regular fa-check",
                                        staticStyle: {
                                          color: "#bfdbfe",
                                          "font-weight": "bold",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    margin: "1rem 0rem",
                                    color: "#4a5565",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Full feature set for B2B with credit notes, partial payments, and FIFO"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { staticClass: "card px-6 pt-6" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            width: "100%",
                            gap: "1rem",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("div", { staticStyle: { display: "grid" } }, [
                            _c("span", { staticClass: "title" }, [
                              _vm._v("Configuration: Traditional B2B"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "subtitle" }, [
                              _vm._v(
                                "Configure candidate selection and the rule cascade"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            { staticClass: "btn-outline btn-dark" },
                            [
                              _c("i", { staticClass: "fa-regular fa-save" }),
                              _vm._v("Save"),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "info-container",
                          staticStyle: { width: "100%" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                width: "100%",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    gap: "1rem",
                                    "margin-bottom": "1rem",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-list",
                                    staticStyle: {
                                      padding: "1rem",
                                      "background-color": "#e0e7ff",
                                      "border-radius": ".25rem",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "grid" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#312c85",
                                            "font-size": "1.1rem",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Selection and Sorting of Candidates"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticStyle: { color: "#4338ca" } },
                                        [
                                          _vm._v(
                                            "Sorts and filters invoices beefore matching"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-empty",
                                  staticStyle: {
                                    "background-color": "white",
                                    cursor: "pointer",
                                    display: "flex",
                                    gap: "0.5rem",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-gear",
                                  }),
                                  _vm._v("Configure Strategy"),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "1rem" } },
                            [
                              _c("small", [
                                _c(
                                  "small",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("Primary Sort:")]
                                ),
                                _vm._v(" FIFO"),
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _c(
                                  "small",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("Secondary:")]
                                ),
                                _vm._v(" None"),
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _c(
                                  "small",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("Max Candidates:")]
                                ),
                                _vm._v(" 50"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#6a7282 !important",
                            "font-weight": "bold",
                            display: "flex",
                            "align-items": "center",
                            margin: "1rem 0rem",
                            gap: "1rem",
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-regular fa-arrow-down" }),
                          _vm._v("Then apply Allocation Rules (Sequential)"),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.rulesOrder != null
                        ? _c(
                            "div",
                            { staticStyle: { width: "100%" } },
                            _vm._l(_vm.rulesOrder, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "card" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        gap: "1rem",
                                        "justify-content": "space-between",
                                        padding: "1rem",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "1rem",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "btn-empty",
                                              staticStyle: {
                                                "background-color":
                                                  "#fbf9fa !important",
                                                padding: "0.25rem 1rem",
                                              },
                                            },
                                            [_vm._v(_vm._s(index + 1))]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                style: {
                                                  display: "flex",
                                                  "justify-content": _vm.rules[
                                                    item
                                                  ].isActive
                                                    ? "end"
                                                    : "left",
                                                  "border-radius": "50px",
                                                  height: "1rem",
                                                  width: "2rem",
                                                  "background-color": _vm.rules[
                                                    item
                                                  ].isActive
                                                    ? "black"
                                                    : "gray",
                                                },
                                                on: {
                                                  click: function () {
                                                    return (_vm.rules[
                                                      item
                                                    ].isActive =
                                                      !_vm.rules[item].isActive)
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticStyle: {
                                                    "border-radius": "50px",
                                                    width: "1rem",
                                                    height: "1rem",
                                                    "background-color": "white",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                    "font-size": "1.1rem",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.rules[item].title
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn",
                                                  on: {
                                                    click: function () {
                                                      return (_vm.rules[
                                                        item
                                                      ].isOpen =
                                                        !_vm.rules[item].isOpen)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    class: [
                                                      "fa-regular",
                                                      {
                                                        "fa-angle-up":
                                                          _vm.rules[item]
                                                            .isOpen,
                                                        "fa-angle-down":
                                                          !_vm.rules[item]
                                                            .isOpen,
                                                      },
                                                    ],
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            !_vm.rules[item].isOpen
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticStyle: {
                                                      color: "#6a7282",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.rules[item]
                                                          .description
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("configuration-modal", {
                                            attrs: { config: _vm.rules[item] },
                                            on: {
                                              update: function (updatedRule) {
                                                return _vm.updateRule(
                                                  item,
                                                  updatedRule
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              class: [
                                                "btn",
                                                { disabled: index == 0 },
                                              ],
                                              staticStyle: {
                                                padding: "0.5rem",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.switchOrder(
                                                    _vm.rules[item],
                                                    index,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-regular fa-arrow-up",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              class: [
                                                "btn",
                                                { disabled: index == 3 },
                                              ],
                                              staticStyle: {
                                                padding: "0.5rem",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.switchOrder(
                                                    _vm.rules[item],
                                                    index,
                                                    0
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-regular fa-arrow-down",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.rules[item].isOpen
                                    ? _c("hr", { staticStyle: { margin: "0" } })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.rules[item].isOpen
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "grid",
                                            "grid-template-columns": "1fr 1fr",
                                            padding: "1rem",
                                            "background-color":
                                              "#f8f9fa !important",
                                          },
                                        },
                                        _vm._l(
                                          Object.entries(_vm.rules[item].param),
                                          function (param, i) {
                                            return _c(
                                              "small",
                                              {
                                                key: i,
                                                staticStyle: {
                                                  color: "#6a7282",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      param[0]
                                                        .split("_")
                                                        .map(function (e) {
                                                          return (
                                                            e
                                                              .slice(0, 1)
                                                              .toUpperCase() +
                                                            e.slice(1)
                                                          )
                                                        })
                                                        .join(" ")
                                                    ) +
                                                    ": "
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(param[1].value)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            { staticClass: "card empty" },
                            [
                              _c("b-spinner", {
                                attrs: { label: "Loading..." },
                              }),
                            ],
                            1
                          ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }